import { render, staticRenderFns } from "./BullScreening.vue?vue&type=template&id=061957a6&scoped=true&"
import script from "./BullScreening.vue?vue&type=script&lang=js&"
export * from "./BullScreening.vue?vue&type=script&lang=js&"
import style0 from "./BullScreening.vue?vue&type=style&index=0&id=061957a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061957a6",
  null
  
)

export default component.exports